import type { App, Plugin } from 'vue';

export interface MenusPluginOptions {
  mountNodeClass?: string;
  mountNodeId?: string;
}

export const DEFAULT_MENUS_PLUGIN_NODE_ID = 'stash-menus-mount-node';

export default <Plugin>{
  install(_app: App, options?: MenusPluginOptions) {
    const mountNodeId = options?.mountNodeId || DEFAULT_MENUS_PLUGIN_NODE_ID;
    let mountNode = document.getElementById(mountNodeId);

    // If the mount node already exists, do nothing
    if (mountNode) {
      return;
    }

    mountNode = document.createElement('div');
    mountNode.id = mountNodeId;
    mountNode.dataset.test = DEFAULT_MENUS_PLUGIN_NODE_ID;

    if (options?.mountNodeClass) {
      mountNode.classList.add(options.mountNodeClass);
    }

    document.body.appendChild(mountNode);
  },
};
